module.exports = __webpack_public_path__ + "img/o-christmas-tree-image.fe2e683c.png";